import {DHXView} from "dhx-optimus";

//import {LinesView} from "views/label/lines.js";
//import {LabelView} from "views/label/label.js";


export class MenuView extends DHXView{
	render(){
		var self = this;
		
		this.ui = self.root.attachMenu({
			iconset: "awesome",
			skin: "dhx_web",

		});
		//this.ui.setIconSize(32);
		self.ui.attachEvent("onClick", (id) => self.callEvent("MenuClick", [id]))
		self._load();
			
	}

	_load(){
		
		let struct = [
				{id:"t1", text:"Find", items:[
					//{id:"t1ch1", text:"child 1"},
					//{id:"t1ch2", text:"child 2"},
				]},
				{id:"t2", text:"Pegelstand", items:[
					//{id:"t2ch1", text:"Lines"},
					//{id:"t2ch2", text:"Patient"},
				]},
				
				
				
			];
		this.ui.loadStruct(struct);
		
		
	}
}


// WEBPACK FOOTER //
// ./sources/views/menu.js